require('./_set-species')('Array');



// WEBPACK FOOTER //
// ./node_modules/.pnpm/core-js@2.6.12/node_modules/core-js/modules/es6.array.species.js